import { useParams } from 'react-router-dom'
import { useGetProfileQuery } from 'root-api'

import { useInvoiceQuery } from './useInvoiceQuery'

export const useInvoiceWithProfile = () => {
  const { profileSlug } = useParams()
  const { loading: invoiceLoading, invoice, error, setInvoice, refetch } = useInvoiceQuery()

  const { data: profile, isLoading: profileLoading } = useGetProfileQuery(
    { slug: profileSlug },
    { skip: !profileSlug },
  )

  return {
    loading: invoiceLoading || profileLoading,
    invoice,
    profile,
    error,
    setInvoice,
    refetch,
  }
}
